import { Reducer } from 'redux'
import * as actions from './actions'

export type MenuState = Readonly<{
  selected: string
}>

export const initState: MenuState = {
  selected: '1'
}

// reducer
export const menuReducer: Reducer<MenuState, actions.MenuActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.SELECT_ITEM:
      return {
        ...state,
        selected: action.payload
      }
    default:
      return state
  }
}
